import square from "@/assets/img/forms/square.svg";
import triangle from "@/assets/img/forms/triangle.svg";
import rhombus from "@/assets/img/forms/rhombus.svg";
import pentagon from "@/assets/img/forms/pentagon.svg";
import octagon from "@/assets/img/forms/octagon.svg";
import circle from "@/assets/img/forms/circle.svg";
import star from "@/assets/img/forms/star.svg";
import heart from "@/assets/img/forms/heart.svg";
import check from "@/assets/img/forms/check.svg";
import cross from "@/assets/img/forms/cross.svg";

const initialColorsState = [
  "#FEDD4D",
  "#FDC60B",
  "#FB9902",
  "#FE2712",
  "#9E0000",
  "#4D36FF",
  "#0291CD",
  "#2A71B0",
  "#FF36CD",
  "#6D398B",
  "#8FEAC9",
  "#4FF507",
  "#66B132",
  "#13AD76",
  "#2F620C",
];

const forms = [
  {
    src: square,
    name: "square",
    svg: `<svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="16"
          height="16"
          rx="2.5"
          stroke="strokeColor"
          fill="fillColor"
        />
      </svg>`,
  },
  {
    src: triangle,
    svg: `<svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.44629 0.711914C8.56319 0.48186 8.8386 0.453215 8.99512 0.625977L9.05371 0.711914L9.05664 0.717773L16.9414 15.7939V15.7949C17.0238 15.9574 17.0142 16.1431 16.9414 16.2871C16.8688 16.4307 16.7635 16.4854 16.6709 16.4854H1.3291C1.23646 16.4853 1.13123 16.4307 1.05859 16.2871C0.994825 16.161 0.979702 16.0029 1.03223 15.8564L1.06152 15.7881L8.44629 0.711914Z"
          stroke="strokeColor"
          fill="fillColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>`,
    name: "triangle",
  },
  {
    src: rhombus,
    svg: `<svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.5 0.5C8.60255 0.5 8.70091 0.54078 8.77344 0.613281L16.3867 8.22656C16.4592 8.29909 16.5 8.39745 16.5 8.5C16.5 8.60254 16.4592 8.70091 16.3867 8.77344L8.77344 16.3867C8.70091 16.4592 8.60254 16.5 8.5 16.5C8.39745 16.5 8.29909 16.4592 8.22656 16.3867L0.613281 8.77344C0.54078 8.70091 0.5 8.60255 0.5 8.5C0.5 8.39745 0.540781 8.29908 0.613281 8.22656L8.22656 0.613281C8.29908 0.540781 8.39745 0.5 8.5 0.5Z"
          stroke="strokeColor"
          fill="fillColor"
        />
      </svg>`,
    name: "rhombus",
  },
  {
    src: pentagon,
    svg: `<svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 0.5C9.05653 0.5 9.11378 0.514268 9.16602 0.543945L9.21582 0.579102L16.8496 6.81543C16.9111 6.86563 16.9594 6.93802 16.9834 7.02441C17.0073 7.11069 17.0051 7.20294 16.9766 7.28711V7.28809L13.9277 16.2363C13.8996 16.3189 13.849 16.386 13.7871 16.4316C13.7257 16.477 13.6557 16.4999 13.5859 16.5H4.41406C4.34432 16.4999 4.27428 16.477 4.21289 16.4316C4.15104 16.386 4.1004 16.3189 4.07227 16.2363L1.02344 7.28809V7.28711C0.994875 7.20294 0.99273 7.11069 1.0166 7.02441C1.04056 6.93802 1.08893 6.86563 1.15039 6.81543L8.78418 0.579102C8.8488 0.526359 8.92472 0.5 9 0.5Z"
          stroke="strokeColor"
          fill="fillColor"
        />
      </svg>`,
    name: "pentagon",
  },
  {
    src: octagon,
    svg: `<svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.30078 0.5H11.6992C11.7522 0.500011 11.8048 0.510567 11.8535 0.53125C11.9022 0.551946 11.9466 0.58204 11.9834 0.620117L16.3896 5.1875C16.4604 5.26102 16.5 5.35894 16.5 5.46094V11.5391C16.5001 11.6158 16.4777 11.6903 16.4365 11.7539L16.3896 11.8135L11.9834 16.3799C11.9466 16.418 11.9022 16.4481 11.8535 16.4688C11.8048 16.4894 11.7522 16.5 11.6992 16.5H5.30078C5.24783 16.5 5.19523 16.4894 5.14648 16.4688C5.09775 16.4481 5.05338 16.418 5.0166 16.3799L0.610352 11.8125C0.53949 11.7389 0.499997 11.6402 0.5 11.5381V5.46094C0.499926 5.38415 0.522326 5.30966 0.563477 5.24609L0.610352 5.18652L5.0166 0.620117C5.05339 0.582041 5.09775 0.551946 5.14648 0.53125C5.19523 0.510567 5.24783 0.500011 5.30078 0.5Z"
          stroke="strokeColor"
          fill="fillColor"
        />
      </svg>`,
    name: "ocatagon",
  },
  {
    src: circle,
    svg: `<svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="8.5" cy="8.5" r="8" stroke="strokeColor" fill="fillColor" />
      </svg>`,
    name: "circle",
  },
  {
    src: star,
    svg: `<svg
        width="19"
        height="17"
        viewBox="0 0 19 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.87011 1.26282C9.12866 0.744839 9.86843 0.746729 10.1243 1.26602L12.0883 5.25142C12.1903 5.45849 12.3879 5.60194 12.6164 5.63485L17.0914 6.27946C17.6665 6.3623 17.8961 7.0693 17.4794 7.47428L14.2395 10.6232C14.0731 10.7849 13.9977 11.0186 14.0381 11.2471L14.806 15.5884C14.9075 16.1624 14.304 16.6017 13.789 16.3288L9.82775 14.23C9.62275 14.1214 9.37725 14.1214 9.17226 14.23L5.20925 16.3299C4.69457 16.6027 4.09138 16.1642 4.19203 15.5905L4.95408 11.2466C4.99407 11.0186 4.91878 10.7856 4.75296 10.6241L1.51732 7.47344C1.10144 7.06847 1.3308 6.36241 1.90527 6.27916L6.35167 5.63478C6.57867 5.60188 6.77515 5.45987 6.87758 5.25464L8.87011 1.26282Z"
          stroke="strokeColor"
          fill="fillColor"
          stroke-linejoin="round"
        />
      </svg>`,
    name: "star",
  },
  {
    src: heart,
    svg: `<svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.9248 0.5H4.92578C5.58705 0.499673 6.24116 0.673637 6.83301 1.01074C7.42534 1.34812 7.93964 1.84001 8.3291 2.44824C8.42097 2.59167 8.57967 2.67862 8.75 2.67871C8.92025 2.67871 9.07893 2.59153 9.1709 2.44824C9.93603 1.25639 11.1846 0.5 12.5752 0.5C14.8383 0.500116 16.7498 2.52721 16.75 5.12695C16.75 7.51531 15.4569 9.84807 13.7441 11.7451C12.1013 13.5646 10.1376 14.9084 8.75 15.4629C7.36244 14.9084 5.39874 13.5646 3.75586 11.7451C2.04309 9.84807 0.75 7.51531 0.75 5.12695C0.750175 2.52721 2.66172 0.500117 4.9248 0.5Z"
          stroke="strokeColor"
          fill="fillColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>`,
    name: "heart",
  },
  {
    src: check,
    svg: `<svg
        width="21"
        height="19"
        viewBox="0 0 21 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.22269 11.9488C0.957844 11.6864 0.945125 11.2625 1.19376 10.9847L3.49475 8.41383C3.76327 8.11381 4.22892 8.10162 4.51278 8.38717L7.05222 10.9417C7.33019 11.2214 7.78417 11.2163 8.05589 10.9306L17.0152 1.51025C17.2827 1.22894 17.7281 1.21909 18.0078 1.48829L20.2444 3.64074C20.5234 3.9093 20.5313 4.35342 20.2621 4.63179L7.82306 17.4908C7.552 17.771 7.10423 17.7758 6.82727 17.5014L1.22269 11.9488Z"
          stroke="strokeColor"
          fill="fillColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>`,
    name: "check",
  },
  {
    src: cross,
    svg: `<svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.41752 5.38104L4.27776 1.24127C3.95606 0.919575 3.43449 0.919575 3.1128 1.24127L1.92703 2.42703L0.741265 3.6128C0.419578 3.93449 0.419578 4.45606 0.741265 4.77776L4.88104 8.91753C5.20273 9.23922 5.20273 9.76079 4.88104 10.0825L0.741265 14.2222C0.419578 14.544 0.419578 15.0655 0.741265 15.3872L3.1128 17.7587C3.43449 18.0804 3.95606 18.0804 4.27776 17.7587L8.41752 13.619C8.73921 13.2973 9.26079 13.2973 9.58248 13.619L13.7222 17.7587C14.0439 18.0804 14.5655 18.0804 14.8872 17.7587L17.2588 15.3872C17.5804 15.0655 17.5804 14.544 17.2588 14.2222L13.119 10.0825C12.7972 9.76079 12.7972 9.23922 13.119 8.91753L17.2588 4.77776C17.5804 4.45606 17.5804 3.93449 17.2588 3.6128L14.8872 1.24127C14.5655 0.919575 14.0439 0.919575 13.7222 1.24127L12.5365 2.42703L9.58248 5.38104C9.26079 5.70273 8.73921 5.70273 8.41752 5.38104Z"
          stroke="strokeColor"
          fill="fillColor"
        />
    </svg>`,
    name: "cross",
  },
];

const state = {
  tags: [],
  colors: initialColorsState,
  forms: forms,
};

export default state;
